/**
 * Gets a property of an object by name or path.
 * @param obj The object.
 * @param name The property name or path.
 * @returns The property of any type.
 */
export function getProperty(obj: any, name: string): any {

	if (!name) return null;
	if (!obj) return null;

	let ref;

	// if it's a deep path...
    if (name.indexOf('.') > -1) {

        try {

			// loop through the path to get the property
            let items = name.split('.'), inScope;
            for (var i = 0; i < items.length; i++) {

                if (i > 0 && !inScope) break;

                let item = items[i];

                if (!inScope) {

                    inScope = !obj ? (window as any)[item] : obj[item];
                }
                else {

                    inScope = inScope[item];
                }
            }
            ref = inScope;
        }
        catch (err) { }
    }
    else {

		ref = obj[name];
    }

    return ref;
}

export function getTypedProperty<T>(obj: any, name: string): T {

	return getProperty(obj, name) as T;
}